export const API_URLS = {
  getAdvanceSearch: '/api/client-verification/advance-search-attributes',
  getDashboardNavItems: '/api/config/clientDashboardNavConfig',
  getClientUser: `/api/user/client-user`,
  getActiveFeatureConfig: `/api/config/active-features`,
  getDashboardData:
    '/api/client-dashboard/dashboard?from=#{from}&to=#{to}&searchText=#{searchText}',
  getBulkInvoices:
    '/api/client-dashboard/bulk-invoices?year=#{year}&month=#{month}',
  getBulkInvoice:
    '/api/client-dashboard/getBulkInvoice?clientId=#{clientId}&startDate=#{startDate}&endDate=#{endDate}',
  getEvaluatorPerformance:
    '/api/client-dashboard/evaluator-performance?from=#{from}&to=#{to}&searchText=#{searchText}',
  getLegacyCaseAppealUrl:
    '/api/verification-modification/legacy-case-appeal-url?caseId=#{caseId}',
  getEvaluatorDetail:
    '/api/client-dashboard/evaluator-detail?opsId=#{opsId}&from=#{from}&to=#{to}&searchText=#{searchText}',
  logOutUrl: `/api/onboarding/logout`,
  getVerificationDetailsById: `/api/verification-details/verification-request/#{verificationId}?fetchApplicant=#{fetchApplicant}`,
  notifications: '/api/notifications',
  updateReadStatus: '/api/notifications/updateReadStatus',
  notificationsStatus: '/api/notifications/getNotificationsStatus',
  logIn: `/api/client/login?email=#{email}&password=#{password}`,
  forgotPassword: '/api/client/forgotPassword',
  resetPassword: '/api/client/resetPassword',
  setPassword: '/api/client/setPassword',
  getAllCasesTrendBars:
    '/api/client-dashboard/cases-trend-bars?barType=#{barType}&caseType=#{caseType}&from=#{from}&to=#{to}',
  getAllCasesTrendMetrics:
    '/api/client-dashboard/cases-trend-metrics?barType=#{barType}&caseType=#{caseType}',
  getAllVerificationsMetrics:
    '/api/client-dashboard/verifications-metrics?from=#{from}&to=#{to}',
  getSlaTableData:
    '/api/client-dashboard/sla-table-data?tableType=#{tableType}&caseType=#{caseType}',
  errorLog: '/api/log',
  getCaseHistoryOfVR:
    '/api/verification-details/case-history?verificationRequestId=#{verificationRequestId}',
  updateLatestPartnerAdminResponse:
    '/api/verification-details/update-latest-partner-admin-response/#{verificationRequestId}',
  getSupportConfig: '/api/cosmos/support-config',
  getVerifications: '/api/client-verification',
  getCSVFileofVerifications:
    '/api/client-verification/verification-csv-file?params=#{params}&levelType=#{levelType}',
  getVerificationListByFilter: '/api/client-verification/filters',
  deleteVerificationRequest:
    '/api/verification-modification/verification?verificationRequestId=#{verificationRequestId}',
  getRefundPayoutsByVRId:
    '/api/payments/get-refund-by-vr/#{verificationRequestId}',
  getPaymentPackageDetailsFromVR: `/api/verification-details/get-payment-package-details/#{verificationRequestId}`,
  reInviteApplicant: '/api/invite-applicant/re-invite',
  getVerificationDetailsByCaseId:
    '/api/verification-details/verification-details-by-case-id?caseId=#{caseId}&fetchApplicant=#{fetchApplicant}',
  getWorkflowStageHistory: `/api/verification-details/workflow-stage-history?entityId=#{entityId}&workflowStage=#{workflowStage}&startTimeStamp=#{startTimeStamp}&endTimeStamp=#{endTimeStamp}`,
  getPreviousReportFiles:
    '/api/verification-details/previous-reports/#{verificationRequestId}',
  publishDownloadDocumentAudit:
    '/api/verification-details/publish-download-document-audit',
  updateUserById: '/api/user/#{userId}',
  getClientTeamMembers:
    '/api/client-management/client-team-members?clientId=#{clientId}',
  createClientUser: '/api/client-management/client-user?clientId=#{clientId}',
  updateClientUser: '/api/client-management/client-user',
  reInviteClientUser: '/api/client-management/client-user/re-invite',
  getCaseOverview: '/api/client-dashboard/case-overview?from=#{from}&to=#{to}',
  getCaseOverviewDetails:
    '/api/client-dashboard/case-overview-details?from=#{from}&to=#{to}&metricType=#{metricType}&start=#{start}&size=#{size}',
  getAutomatedRejectionReasoning:
    '/api/client-dashboard/automated-rejection-reasoning?from=#{from}&to=#{to}',
  getManualRejectionReasoning:
    '/api/client-dashboard/manual-rejection-reasoning?from=#{from}&to=#{to}',
  getVeriflowCases: '/api/client-verification/veriflow-cases'
};

export const VERIFICATION_API_URLS = {
  getAppealDetails:
    '/api/verification-modification/appeal-details?verificationRequestId=#{verificationRequestId}',
  getRequestCorrectionDetails:
    '/api/verification-modification/request-correction-details?verificationRequestId=#{verificationRequestId}',
  raiseAppealError:
    '/api/verification-modification/raise-appeal-error?subDomain=#{subDomain}',
  verificationOverviewPdf: '/api/verification-details/overviewPdf',
  getVerificationOverviewSummary: `/api/verification-details/overview-summary?verificationRequestId=#{verificationRequestId}`,
  getVerificationOverview: `/api/verification-creation/overview`,
  moveToVerification: '/api/verification-creation/move-to-verification'
};

export const DTD_API_URLS = {
  getConfig: '/api/dtd/get-client-config',
  postFileUpload: `${process.env.NEXT_PUBLIC_DTD_DOCUMENT_SERVICE_URL}/tamperingService/dtdPortal/documents/multiple/uploadFileAsObj`,
  getReport: '/api/dtd/get-report?startDate=#{startDate}&endDate=#{endDate}',
  downloadReport: '/api/dtd/download-report/#{transactionId}'
};

export const CREDENTIALS_SUBSCRIPTION_API_URLS = {
  validateTrueProof: '/api/credentials-subscription/validate-pdf'
};

export const DOCUMENT_UPLOAD_URL = `${process.env.NEXT_PUBLIC_DOCUMENT_SERVICE_URL}/upload`;
